module.exports = __webpack_public_path__ + "img/magnifying-glass.70508116.svg";